import { createContext, useContext } from "react";

import type { ProductItem } from "@/store/products/types";
import type { IdleState, State } from "@/store/types";

type InitialCurrentProductState = { productId?: string };

export type CurrentProductState =
  | IdleState<InitialCurrentProductState>
  | { status: "loaded"; state: ProductItem }
  | State<"notFound", InitialCurrentProductState>;

type ProductPageContextResults = {
  currentProduct: CurrentProductState;
};

export const ProductPageContext = createContext<ProductPageContextResults>(
  {} as ProductPageContextResults,
);

export const useProductPageContext = () => useContext(ProductPageContext);
